import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=4256fa68&"
import script from "./BookingTable.vue?vue&type=script&lang=ts&"
export * from "./BookingTable.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports